// Utility functions and constants for map print preview calculations
import { get as getProjection } from 'ol/proj';
import View from 'ol/View';
import { getCenter } from 'ol/extent';
import Units, { METERS_PER_UNIT } from 'ol/proj/Units.js';

// Conversion constant: number of inches in a meter, based on OpenLayers' feet-to-meter ratio
export const INCHES_PER_METER = 1 / METERS_PER_UNIT[Units.FEET] * 12;
// Standard screen DPI (dots per inch) used for print preview calculations
export const DEFAULT_DPI = 96;

// Create a new OpenLayers View for the given projection, centered on the projection's extent
export const getView = (projection) => {
    const newProj = getProjection(projection);
    const newProjExtent = newProj.getExtent();
    return new View({
        enableRotation: false,
        projection: newProj,
        center: getCenter(newProjExtent || [0, 0, 0, 0]),
        zoom: 0,
        extent: newProjExtent || undefined
    });
};

// Convert a map scale (e.g., "1250") to a map resolution for the view.
// Formula: resolution = scale / (dpi * metersPerUnit * inchesPerMeter)
// - scale: denominator of the scale (e.g., 1250 for 1:1250)
// - dpi: dots per inch (screen resolution)
// - metersPerUnit: conversion factor for projection units to meters
// - inchesPerMeter: number of inches in a meter
export const scaleToResolution = (scale, projection) => {
    const proj = getProjection(projection);
    const unit = proj.getUnits();
    const metersPerUnit = METERS_PER_UNIT[unit];
    const inchesPerMeter = INCHES_PER_METER;
    // The result gives the map resolution (map units per pixel) for the given scale
    return parseInt(scale) / (DEFAULT_DPI * metersPerUnit * inchesPerMeter);
};
